const routes = [
  {
    // announcements
    path: "/page/announcements",
    name: "Announcements",
    component: () =>
      import(
        /* webpackChunkName:'announcements' */ "../views/Page/Announcements/Announcements.vue"
      ),
  },
  {
    // assessments
    path: "/page/assessments",
    name: "Assessments",
    component: () =>
      import(
        /* webpackChunkName:'assessments' */ "../views/Page/Assessments/Assessments.vue"
      ),
  },
  {
    // attendance
    path: "/page/attendance",
    name: "Attendance",
    component: () =>
      import(
        /* webpackChunkName:'attendance' */ "../views/Page/Attendance/Attendance.vue"
      ),
  },
  {
    // attendance
    path: "/page/attendance_admin",
    name: "AttendanceAdmin",
    component: () =>
      import(
        /* webpackChunkName:'attendance' */ "../views/Page/AttendanceAdmin/index.vue"
      ),
  },
  {
    // activities
    path: "/page/Activities",
    name: "activities",
    component: () =>
      import(
        /* webpackChunkName:'attendance' */ "../views/Page/Activities/Activities.vue"
      ),
  },
  {
    // activities
    path: "/page/Activities_v2",
    name: "activitiesv2",
    component: () =>
      import(
        /* webpackChunkName:'attendance' */ "../views/Page/Activities_v2/Activities.vue"
      ),
  },
  {
    // activity detail
    path: "/page/Activities_v2/:id",
    name: "activities-v2-detail",
    component: () =>
      import(
        /* webpackChunkName:'activities-detail' */ "../views/Page/Activities_v2/ActivityDetail.vue"
      ),
  },
  {
    // activity attend
    path: "/page/Activities_v2/:id/attend",
    name: "activities-v2-attend",
    component: () =>
      import(
        /* webpackChunkName:'activities-attend' */ "../views/Page/Activities_v2/ActivityAttend.vue"
      ),
  },
  {
    // activities
    path: "/page/activities-master/:userId?",
    name: "ActivitiesMaster",
    component: () =>
      import(
        /* webpackChunkName:'ActivitiesMaster' */ "../views/Page/Activities/components/Master.vue"
      ),
  },
  {
    // Edu_contents
    path: "/page/activityStudents/:Activity",
    name: "activityStudents",
    component: () =>
      import(
        /* webpackChunkName:'Edu_contents' */ "../views/Page/Activities/components/studentsDataTable.vue"
      ),
  },
  {
    // activities
    path: "/page/studentActivities",
    name: "studentActivities",
    component: () =>
      import(
        /* webpackChunkName:'attendance' */ "../views/Page/Activities/studentActivities.vue"
      ),
  },
  {
    // activities
    path: "/page/activity-user-answer-report/:id",
    name: "ActivityUserAnswerReport",
    component: () =>
      import(
        /* webpackChunkName:'ActivityUserAnswerReport' */ "../views/Page/Activities/Reports.vue"
      ),
  },
  {
    // ActivityUserAnswerReportSelect
    path: "/page/activity-user-answer-report",
    name: "ActivityUserAnswerReportSelect",
    component: () =>
      import(
        /* webpackChunkName:'ActivityUserAnswerReportSelect' */ "../views/Page/Activities/ReportsSelect.vue"
      ),
  },
  {
    // activities
    path: "/page/student-answers-master/:userId",
    name: "StudentAnswersMaster",
    component: () =>
      import(
        /* webpackChunkName:'StudentAnswersMaster' */ "../views/Page/Activities/StudentAnswersMaster.vue"
      ),
  },
  {
    // activities
    path: "/page/studentAnswers",
    name: "studentAnswers",
    component: () =>
      import(
        /* webpackChunkName:'studentAnswers' */ "../views/Page/Activities/components/studentAnswers.vue"
      ),
  },
  {
    // attendance
    path: "/page/SessionAttendance/:session_room_id/:session_id",
    name: "SessionAttendance",
    component: () =>
      import(
        /* webpackChunkName:'SessionAttendance' */ "../views/Page/SessionAttendance/SessionAttendance.vue"
      ),
  },

  {
    // badges
    path: "/page/badges",
    name: "Badges",
    component: () =>
      import(/* webpackChunkName:'badges' */ "../views/Page/Badges/Badges.vue"),
  },
  {
    // badges students
    path: "/badges/assign-student/:badgeId",
    name: "BadgeStudents",
    component: () =>
      import(
        /* webpackChunkName: "badges" */ "../views/Page/Badges/BadgeStudents.vue"
      ),
  },
  {
    // questions
    path: "/page/questions",
    name: "CardQuestions",
    component: () =>
      import(
        /* webpackChunkName:'questions' */ "../views/Page/Questions/CardQuestions.vue"
      ),
  },
  {
    // questions
    path: "/page/questions/:courseId",
    name: "Questions",
    component: () =>
      import(
        /* webpackChunkName:'questions' */ "../views/Page/Questions/Questions.vue"
      ),
  },
  {
    // blogs
    path: "/page/blogs",
    name: "Blogs",
    component: () =>
      import(/* webpackChunkName:'blogs' */ "../views/Page/Blogs/Blogs.vue"),
  },
  {
    // blogs
    path: "/page/log",
    name: "Log",
    component: () =>
      import(/* webpackChunkName:'blogs' */ "../views/Page/Log/Log.vue"),
  },
  {
    // countries
    path: "/page/countries",
    name: "Countries",
    component: () =>
      import(
        /* webpackChunkName:'countries' */ "../views/Page/Countries/Countries.vue"
      ),
  },
  {
    // Certifications
    path: "/page/my-certifications",
    name: "Certifications",
    component: () =>
      import(
        /* webpackChunkName:'Certifications' */ "../views/Page/Certifications/CertificationsST.vue"
      ),
  },
  {
    // Certifications
    path: "/page/certifications",
    name: "Certification",
    component: () =>
      import(
        /* webpackChunkName:'Certifications' */ "../views/Page/Certifications/Certifications.vue"
      ),
  },
  {
    // Certifications
    path: "/page/certifications-editor",
    name: "CertificationEditor",
    component: () =>
      import(
        /* webpackChunkName:'CertificationEditor' */ "../views/Page/Certifications/Editor.vue"
      ),
  },
  {
    // Certifications
    path: "/page/assign-certificate",
    name: "AssignCertificate",
    component: () =>
      import(
        /* webpackChunkName:'Certifications' */ "../views/Page/Certifications/AssignCertificate.vue"
      ),
  },
  {
    // Certifications
    path: "/page/eduProgram/users",
    name: "EduProgramUsers",
    component: () =>
      import(
        /* webpackChunkName:'EduProgramUsers' */ "../views/Page/Users/EduProgram.vue"
      ),
  },
  {
    // Certifications
    path: "/page/eduProgram/invoice/:id",
    name: "InvoicePreview",
    component: () =>
      import(
        /* webpackChunkName:'InvoicePreview' */ "../views/Page/invoice-preview/InvoicePreview.vue"
      ),
  },
  {
    // Payment
    path: "/page/eduProgram/:eduProgramId/payment/:invoiceId",
    name: "Payment",
    component: () =>
      import(
        /* webpackChunkName:'Payment' */ "../views/Page/invoice-preview/Payment.vue"
      ),
  },
  {
    // studyRoom
    path: "/page/eduProgram/studyRoom",
    name: "StudyRoom",
    component: () =>
      import(/* webpackChunkName:'StudyRoom' */ "../views/Page/Online/VC.vue"),
  },
  //
  {
    // Certifications
    path: "/page/eduProgram/details/:eduProgramId?",
    name: "EduProgramDetails",
    component: () =>
      import(
        /* webpackChunkName:'EduProgramDetails' */ "../views/Page/Edu_programs/profile/Profile.vue"
      ),
  },
  //
  {
    // wizard
    path: "/page/eduProgram/wizard",
    name: "Wizard",
    component: () =>
      import(
        /* webpackChunkName:'wizard' */ "../views/Page/Edu_programs/Wizard.vue"
      ),
  },

  {
    // Certifications
    path: "/page/FAQ",
    name: "FAQ",
    component: () =>
      import(/* webpackChunkName:'FAQ' */ "../views/Page/faq/Faq.vue"),
  },
  {
    // Edu_contents
    path: "/page/edu-contents/:EduCourse",
    name: "EduContents",
    component: () =>
      import(
        /* webpackChunkName:'Edu_contents' */ "../views/Page/Edu_contents/Edu_contents.vue"
      ),
  },
  {
    // Edu_contents
    path: "/page/edu-contents-add",
    name: "AddEduContents",
    component: () =>
      import(
        /* webpackChunkName:'AddEduContents' */ "../views/Page/Edu_contents/EduContentFormWizardIcon.vue"
      ),
  },

  {
    // edu_courses
    path: "/page/edu_courses",
    name: "Edu_courses",
    component: () =>
      import(
        /* webpackChunkName:'edu_courses' */ "../views/Page/Edu_courses/Edu_courses.vue"
      ),
  },
  {
    // edu_courses
    path: "/page/Courses",
    name: "Courses",
    component: () =>
      import(
        /* webpackChunkName:'edu_courses' */ "../views/Page/Edu_courses/Courses.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/startingPoint",
    name: "StartingPoint",
    component: () =>
      import(
        /* webpackChunkName:'StartingPoint' */ "../views/Page/Edu_programs/StartingPoint.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/completionPercentage",
    name: "CompletionPercentage",
    component: () =>
      import(
        /* webpackChunkName:'CompletionPercentage' */ "../views/Page/Edu_programs/CompletionPercentage.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/PathEduProgram",
    name: "PathEduProgram",
    component: () =>
      import(
        /* webpackChunkName:'PathEduProgram' */ "../views/Page/Edu_programs/PathEduProgram.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/CoursePlan",
    name: "CoursePlan",
    component: () =>
      import(
        /* webpackChunkName:'CoursePlan' */ "../views/Page/Edu_programs/CoursePlan.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/edu_programs",
    name: "EduPrograms",
    component: () =>
      import(
        /* webpackChunkName:'EduPrograms' */ "../views/Page/Edu_programs/Edu_programs.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/edu_programs/:eduProgramId",
    name: "Edu_programs",
    component: () =>
      import(
        /* webpackChunkName:'Edu_programs' */ "../views/Page/Edu_programs/Show.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/edu_programs/setting/:eduProgramId",
    name: "EduProgramSetting",
    component: () =>
      import(
        /* webpackChunkName:'EduProgramSetting' */ "../views/Page/Edu_programs/EduProgramSetting.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/StudentProgram",
    name: "StudentProgram",
    component: () =>
      import(
        /* webpackChunkName:'StudentProgram' */ "../views/Page/Edu_programs/StudentProgram.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/eduPrograms/UnSubscribed",
    name: "UnSubscribed",
    component: () =>
      import(
        /* webpackChunkName:'UnSubscribed' */ "../views/Page/Edu_programs/UnSubscribed.vue"
      ),
  },
  {
    // discussions
    path: "/page/discussions",
    name: "Discussions",
    component: () =>
      import(
        /* webpackChunkName:'discussions' */ "../views/Page/Discussions/Discussions.vue"
      ),
  },
  {
    // discussions
    path: "/page/discussions/:id",
    name: "DiscussionsDetails",
    component: () =>
      import(
        /* webpackChunkName:'discussions' */ "../views/Page/Discussions/DiscussionsDetails.vue"
      ),
  },
  {
    // edu_schemes
    path: "/page/edu_schemes",
    name: "Edu_schemes",
    component: () =>
      import(
        /* webpackChunkName:'edu_schemes' */ "../views/Page/Edu_schemes/Edu_schemes.vue"
      ),
  },
  {
    // edu_schemes
    path: "/page/shared-lectures",
    name: "SharedLectures",
    component: () =>
      import(
        /* webpackChunkName:'SharedLectures' */ "../views/Page/Edu_schemes/EduContentRoom.vue"
      ),
  },
  {
    // edu_seasons
    path: "/page/edu_seasons",
    name: "Edu_seasons",
    component: () =>
      import(
        /* webpackChunkName:'edu_seasons' */ "../views/Page/Edu_seasons/Edu_seasons.vue"
      ),
  },
  {
    // events
    path: "/page/events",
    name: "Events",
    component: () =>
      import(
        /* webpackChunkName:'events' */ "../views/Page/Calendar/Calendar.vue"
      ),
  },
  {
    // exams
    path: "/page/exams",
    name: "Exams",
    component: () =>
      import(/* webpackChunkName:'exams' */ "../views/Page/Exams/Exams.vue"),
  },
  {
    // exams
    path: "/page/exams/:id/:courseId",
    name: "QuestionsExams",
    component: () =>
      import(
        /* webpackChunkName:'Questions' */ "../views/Page/Exams/components/Questions.vue"
      ),
  },
  {
    // exams
    path: "/page/exam/:id",
    name: "Exam",
    component: () =>
      import(/* webpackChunkName:'exams' */ "../views/Page/Exams/Exam.vue"),
  },
  {
    // examsQuestions
    path: "/page/exams-questions",
    name: "ExamsQuestions",
    component: () =>
      import(
        /* webpackChunkName:'examsQuestions' */ "../views/Page/ExamsQuestions/ExamsQuestions.vue"
      ),
  },
  {
    // results
    path: "/page/results",
    name: "Results",
    component: () =>
      import(
        /* webpackChunkName:'results' */ "../views/Page/Results/Results.vue"
      ),
  },
  {
    // faqs
    path: "/page/faqs",
    name: "Faqs",
    component: () =>
      import(/* webpackChunkName:'faqs' */ "../views/Page/Faqs/Faqs.vue"),
  },
  {
    // departments
    path: "/page/departments",
    name: "Departments",
    component: () =>
      import(
        /* webpackChunkName:'departments' */ "../views/Page/Departments/Departments.vue"
      ),
  },
  {
    // increments
    path: "/page/increments",
    name: "Increments",
    component: () =>
      import(
        /* webpackChunkName:'increments' */ "../views/Page/Increments/Increments.vue"
      ),
  },
  {
    // bonuses
    path: "/page/bonuses",
    name: "Bonuses",
    component: () =>
      import(
        /* webpackChunkName:'bonuses' */ "../views/Page/Bonuses/Bonuses.vue"
      ),
  },
  {
    // deductions
    path: "/page/deductions",
    name: "Deductions",
    component: () =>
      import(
        /* webpackChunkName:'deductions' */ "../views/Page/Deductions/Deductions.vue"
      ),
  },
  {
    // loans
    path: "/page/loans",
    name: "Loans",
    component: () =>
      import(/* webpackChunkName:'loans' */ "../views/Page/Loans/Loans.vue"),
  },
  {
    // invoice
    path: "/page/invoice",
    name: "Invoice",
    component: () =>
      import(
        /* webpackChunkName:'invoice' */ "../views/Page/Invoice/Invoice.vue"
      ),
  },
  {
    // languages
    path: "/page/languages",
    name: "Languages",
    component: () =>
      import(
        /* webpackChunkName:'languages' */ "../views/Page/Languages/Languages.vue"
      ),
  },
  {
    // categories
    path: "/page/categories",
    name: "Categories",
    component: () =>
      import(
        /* webpackChunkName:'categories' */ "../views/Page/Categories/Categories.vue"
      ),
  },
  {
    // file_settings
    path: "/page/file_settings",
    name: "File_settings",
    component: () =>
      import(
        /* webpackChunkName:'file_settings' */ "../views/Page/File_settings/File_settings.vue"
      ),
  },
  {
    // file_settings
    path: "/page/file-system",
    name: "FileSystem",
    component: () =>
      import(
        /* webpackChunkName:'file_settings' */ "../views/Page/FileSystem/FileSystem.vue"
      ),
  },
  {
    // file_settings
    path: "/page/student-sttings",
    name: "studentSttings",
    component: () =>
      import(
        /* webpackChunkName:'file_settings' */ "../views/Page/Sttings/studentSttings.vue"
      ),
  },
  //FileSystem
  {
    // tags
    path: "/page/tags",
    name: "Tags",
    component: () =>
      import(/* webpackChunkName:'tags' */ "../views/Page/Tags/Tags.vue"),
  },
  {
    // licenses
    path: "/page/licenses",
    name: "Licenses",
    component: () =>
      import(
        /* webpackChunkName:'licenses' */ "../views/Page/Licenses/Licenses.vue"
      ),
  },
  {
    // comment
    path: "/page/comment",
    name: "Comment",
    component: () =>
      import(
        /* webpackChunkName:'comment' */ "../views/Page/Comment/Comment.vue"
      ),
  },
  {
    // library
    path: "/page/library",
    name: "Library",
    component: () =>
      import(
        /* webpackChunkName:'library' */ "../views/Page/Library/Library.vue"
      ),
  },
  {
    // download
    path: "/page/DownloadExcel",
    name: "DownloadExcel",
    component: () =>
      import(
        /* webpackChunkName:'DownloadExcel' */ "../views/Page/Edu_programs/DownloadExcel.vue"
      ),
  },
  {
    // library
    path: "/page/library/Search",
    name: "LibrarySearch",
    component: () =>
      import(
        /* webpackChunkName:'Search' */ "../views/Page/Library/Search.vue"
      ),
  },
  {
    // library
    path: "/page/library/book/:id",
    name: "LibraryDetails",
    component: () =>
      import(
        /* webpackChunkName:'LibraryDetails' */ "../views/Page/Library/LibraryDetails.vue"
      ),
  },
  {
    // masterAnnouncements
    path: "/page/master-announcements",
    name: "MasterAnnouncements",
    component: () =>
      import(
        /* webpackChunkName:'masterAnnouncements' */ "../views/Page/MasterAnnouncements/MasterAnnouncements.vue"
      ),
  },
  {
    // masters
    path: "/page/MasterStudents",
    name: "MasterStudents",
    component: () =>
      import(
        /* webpackChunkName:'masters' */ "../views/Page/MasterStudents/Students.vue"
      ),
  }, //
  {
    // masters
    path: "/page/masters",
    name: "Masters",
    component: () =>
      import(
        /* webpackChunkName:'masters' */ "../views/Page/Masters/Masters.vue"
      ),
  }, //
  {
    // masters
    path: "/page/assign-supervisors/:master_id",
    name: "AssignSupervisors",
    component: () =>
      import(
        /* AssignSupervisors:'masters' */ "../views/Page/Masters/AssignSupervisors.vue"
      ),
  }, //
  {
    // masters
    path: "/page/thesis",
    name: "Thesis",
    component: () =>
      import(
        /* AssignSupervisors:'masters' */ "../views/Page/Masters/Thesis.vue"
      ),
  }, //
  {
    // masters
    path: "/page/thesis-admin/:masterId/:userId",
    name: "ThesisAdmin",
    component: () =>
      import(
        /* AssignSupervisors:'ThesisAdmin' */ "../views/Page/Masters/ThesisAdmin.vue"
      ),
  }, //
  {
    // masters
    path: "/page/approval-of-the-proposal",
    name: "ApprovalOfTheProposal",
    component: () =>
      import(
        /* AssignSupervisors:'ApprovalOfTheProposal' */ "../views/Page/Masters/components/ApprovalOfTheProposal.vue"
      ),
  }, //
  {
    // masters
    path: "/page/plan-structuring-phase",
    name: "PlanStructuringPhase",
    component: () =>
      import(
        /* AssignSupervisors:'PlanStructuringPhase' */ "../views/Page/Masters/components/PlanStructuringPhase.vue"
      ),
  }, //
  {
    // masters
    path: "/page/first-defense",
    name: "FirstDefense",
    component: () =>
      import(
        /* AssignSupervisors:'FirstDefense' */ "../views/Page/Masters/components/FirstDefense.vue"
      ),
  }, //
  {
    // masters
    path: "/page/second-defense",
    name: "SecondDefense",
    component: () =>
      import(
        /* AssignSupervisors:'SecondDefense' */ "../views/Page/Masters/components/SecondDefense.vue"
      ),
  }, //
  {
    // masters
    path: "/page/discussion",
    name: "Discussion",
    component: () =>
      import(
        /* AssignSupervisors:'Discussion' */ "../views/Page/Masters/components/Discussion.vue"
      ),
  }, //
  {
    // masters
    path: "/page/deliverables",
    name: "Deliverables",
    component: () =>
      import(
        /* AssignSupervisors:'Discussion' */ "../views/Page/Masters/components/Deliverables.vue"
      ),
  }, //
  {
    // masters
    path: "/page/graduation",
    name: "Graduation",
    component: () =>
      import(
        /* AssignSupervisors:'Graduation' */ "../views/Page/Masters/components/Graduation.vue"
      ),
  }, //
  {
    // RequestNewMaster
    path: "/page/request-new-master",
    name: "RequestNewMaster",
    component: () =>
      import(
        /* webpackChunkName:'RequestNewMaster' */ "../views/Page/Masters/RequestNewMaster.vue"
      ),
  },
  {
    // masterDiscussion
    path: "/page/master-discussion",
    name: "MasterDiscussion",
    component: () =>
      import(
        /* webpackChunkName:'masterDiscussion' */ "../views/Page/MasterDiscussion/MasterDiscussion.vue"
      ),
  },
  {
    // masterEditorFormat
    path: "/page/master-editor-format",
    name: "MasterEditorFormat",
    component: () =>
      import(
        /* webpackChunkName:'masterEditorFormat' */ "../views/Page/MasterEditorFormat/MasterEditorFormat.vue"
      ),
  },
  {
    // masterReferences
    path: "/page/master-references",
    name: "MasterReferences",
    component: () =>
      import(
        /* webpackChunkName:'masterReferences' */ "../views/Page/MasterReferences/MasterReferences.vue"
      ),
  },
  {
    // masterSemenar
    path: "/page/master-semenar",
    name: "MasterSemenar",
    component: () =>
      import(
        /* webpackChunkName:'masterSemenar' */ "../views/Page/MasterSemenar/MasterSemenar.vue"
      ),
  },
  {
    // masterStatus
    path: "/page/master-status",
    name: "MasterStatus",
    component: () =>
      import(
        /* webpackChunkName:'masterStatus' */ "../views/Page/MasterStatus/MasterStatus.vue"
      ),
  },
  {
    // masterTeachers
    path: "/page/master-teachers",
    name: "MasterTeachers",
    component: () =>
      import(
        /* webpackChunkName:'masterTeachers' */ "../views/Page/MasterTeachers/MasterTeachers.vue"
      ),
  },
  {
    // masterType
    path: "/page/master-type",
    name: "MasterType",
    component: () =>
      import(
        /* webpackChunkName:'masterType' */ "../views/Page/MasterType/MasterType.vue"
      ),
  },
  {
    // nationality
    path: "/page/nationality",
    name: "Nationality",
    component: () =>
      import(
        /* webpackChunkName:'nationality' */ "../views/Page/Nationality/Nationality.vue"
      ),
  },
  // {
  //   // newMaster
  //   path: '/page/new-master',
  //   name: 'NewMaster',
  //   component: () => import(/* webpackChunkName:'newMaster' */ '../views/Page/NewMaster/NewMaster.vue')

  // },
  {
    // meetings
    path: "/page/meetings",
    name: "Meetings",
    component: () =>
      import(
        /* webpackChunkName:'meetings' */ "../views/Page/Meetings/Meetings.vue"
      ),
  },
  {
    // meetings
    path: "/page/connect",
    name: "Connect",
    component: () =>
      import(
        /* webpackChunkName:'meetings' */ "../views/Page/Connect/Connect.vue"
      ),
  },
  {
    // notificationsactions
    path: "/page/notifications-actions",
    name: "Notificationsactions",
    component: () =>
      import(
        /* webpackChunkName:'notificationsactions' */ "../views/Page/NotificationsActions/NotificationsActions"
      ),
  },
  {
    // online_session
    path: "/page/online_session",
    name: "OnlineSession",
    component: () =>
      import(
        /* webpackChunkName:'online_session' */ "../views/Page/Online_session/Online_session.vue"
      ),
  },
  {
    // online_session
    path: "/page/online-session-now",
    name: "OnlineSessionNow",
    component: () =>
      import(
        /* webpackChunkName:'online_session' */ "../views/Page/Online_session/Online_sessionNow.vue"
      ),
  },
  {
    // online_session
    path: "/page/online-details/:id",
    name: "OnlineDetails",
    component: () =>
      import(
        /* webpackChunkName:'Details' */ "../views/Page/Online/Details.vue"
      ),
  },
  //SessionAttendance
  {
    // SessionAttendance
    path: "/page/my-session-attendance",
    name: "MySessionAttendance",
    component: () =>
      import(
        /* webpackChunkName:'SessionAttendance' */ "../views/Page/Online_session/SessionAttendance.vue"
      ),
  },
  {
    // SessionAttendance
    path: "/page/session-attendance/:roomId/:userId",
    name: "UserSessionAttendance",
    component: () =>
      import(
        /* webpackChunkName:'UserSessionAttendance' */ "../views/Page/Online_session/SessionAttendance.vue"
      ),
  },
  {
    // Apology
    path: "/page/apology",
    name: "Apology",
    component: () =>
      import(
        /* webpackChunkName:'Apology' */ "../views/Page/Apology/Apology.vue"
      ),
  },
  {
    // Dashborad
    path: "/page/online-dashborad",
    name: "Dashborad",
    component: () =>
      import(
        /* webpackChunkName:'Dashborad' */ "../views/Page/Online/Dashborad.vue"
      ),
  },
  {
    // polls
    path: "/page/polls",
    name: "Polls",
    component: () =>
      import(/* webpackChunkName:'polls' */ "../views/Page/Polls/Polls.vue"),
  },
  // {
  //   // polls
  //   path: '/page/poll/chart',
  //   name: 'Polls',
  //   component: () => import(/* webpackChunkName:'Chart' */ '../views/Page/Polls/components/ChartContainer'),

  // },
  {
    // pollsQuestions
    path: "/page/pollsQuestions/:pollId",
    name: "PollsQuestions",
    component: () =>
      import(
        /* webpackChunkName:'pollsQuestions' */ "../views/Page/PollsQuestions/PollsQuestions.vue"
      ),
  },

  {
    // program_lists
    path: "/page/program-lists",
    name: "Program_lists",
    component: () =>
      import(
        /* webpackChunkName:'program_lists' */ "../views/Page/Program_lists/Program_lists.vue"
      ),
  },
  {
    // roles
    path: "/page/roles",
    name: "Roles",
    component: () =>
      import(/* webpackChunkName:'roles' */ "../views/Page/Roles/Roles.vue"),
  },
  {
    // rooms
    path: "/page/rooms",
    name: "Rooms",
    component: () =>
      import(/* webpackChunkName:'rooms' */ "../views/Page/Rooms/Rooms.vue"),
  },
  {
    // users
    path: "/page/users",
    name: "Users",
    component: () =>
      import(/* webpackChunkName:'Users' */ "../views/Page/Users/Users.vue"),
  },
  {
    // users
    path: "/page/student",
    name: "Students",
    component: () =>
      import(/* webpackChunkName:'students' */ "../views/Page/Users/Users.vue"),
  },
  {
    // users
    path: "/page/teachers",
    name: "Teachers",
    component: () =>
      import(/* webpackChunkName:'teacher' */ "../views/Page/Users/Users.vue"),
  },
  {
    // QuranProgramsStudents
    path: "/page/quran-programs-students",
    name: "QuranProgramsStudents",
    component: () =>
      import(
        /* webpackChunkName:'teacher' */ "../views/Page/QuranProgramsStudents/Users.vue"
      ),
  },
  {
    // QuranProgramsTeachers
    path: "/page/quran-programs-teachers",
    name: "QuranProgramsTeachers",
    component: () =>
      import(
        /* webpackChunkName:'teacher' */ "../views/Page/QuranProgramsTeachers/Users.vue"
      ),
  },
  {
    // students
    path: "/page/profile/:id?",
    name: "profile",
    component: () =>
      import(
        /* webpackChunkName:'profile' */ "../views/Page/Users/users-view/UsersView.vue"
      ),
  },
  {
    path: "/page/profile-delete",
    name: "deleteAccount",
    component: () =>
      import(
        /* webpackChunkName:'deleteAccount' */ "../views/Page/Users/delete-account/DeleteAccount.vue"
      ),
  },
  {
    // degrees
    path: "/page/degrees",
    name: "Degrees",
    component: () =>
      import(
        /* webpackChunkName:'degrees' */ "../views/Page/Degrees/Degrees.vue"
      ),
  },
  {
    // FormData
    path: "/page/forms",
    name: "dynamicForm",
    component: () =>
      import(
        /* webpackChunkName:'degrees' */ "../views/Page/FormData/FormData.vue"
      ),
  },
  {
    // ac_qualifications
    path: "/page/ac_qualifications",
    name: "Ac_qualifications",
    component: () =>
      import(
        /* webpackChunkName:'ac_qualifications' */ "../views/Page/Ac_qualifications/Ac_qualifications.vue"
      ),
  },
  //cms

  {
    // news
    path: "/page/news",
    name: "News",
    component: () =>
      import(/* webpackChunkName:'news' */ "../views/Page/CMS/News/News.vue"),
  },
  {
    //   Supervising
    path: "/page/supervising",
    name: "Supervising",
    component: () =>
      import(
        /* webpackChunkName:'Supervising' */ "../views/Page/CMS/Supervising/Supervising.vue"
      ),
  },
  {
    // video
    path: "/page/video-gallery/:type",
    name: "VideoGallery",
    component: () =>
      import(
        /* webpackChunkName:'VideoGallery' */ "../views/Page/CMS/VideoGallery/VideoGallery.vue"
      ),
  },
  {
    // video
    path: "/page/video/:videoGalleryId",
    name: "Video",
    component: () =>
      import(
        /* webpackChunkName:'video' */ "../views/Page/CMS/Video/Video.vue"
      ),
  },
  {
    // menu
    path: "/page/menu/:id",
    name: "Menu",
    component: () =>
      import(/* webpackChunkName:'menu' */ "../views/Page/CMS/Menu/Menu.vue"),
  },
  {
    // get-faqs
    path: "/page/get-faqs",
    name: "Get-faqs",
    component: () =>
      import(
        /* webpackChunkName:'get-faqs' */ "../views/Page/CMS/Get-faqs/Get-faqs.vue"
      ),
  },
  {
    // pages
    path: "/page/pages",
    name: "Pages",
    component: () =>
      import(
        /* webpackChunkName:'pages' */ "../views/Page/CMS/Pages/Pages.vue"
      ),
  },
  {
    // pages
    path: "/page/about",
    name: "About",
    component: () =>
      import(
        /* webpackChunkName:'About' */ "../views/Page/CMS/About/About.vue"
      ),
  },
  {
    // slider
    path: "/page/slider",
    name: "Slider",
    component: () =>
      import(
        /* webpackChunkName:'slider' */ "../views/Page/CMS/Slider/Slider.vue"
      ),
  },
  {
    // Edu_cours_programs
    path: "/page/course-programs",
    name: "EduCoursePrograms",
    component: () =>
      import(
        /* webpackChunkName:'Edu_course_programs' */ "../views/Page/Edu_course_programs/Edu_course_programs.vue"
      ),
  },
  {
    // edu_programs
    path: "/page/course-programs/setting/:eduProgramId",
    name: "EduCourseProgramsSetting",
    component: () =>
      import(
        /* webpackChunkName:'EduProgramSetting' */ "../views/Page/Edu_course_programs/EduProgramSetting.vue"
      ),
  },
  {
    // exams
    path: "/page/course-exams",
    name: "CourseExams",
    component: () =>
      import(
        /* webpackChunkName:'CourseExams' */ "../views/Page/CourseExams/Exams.vue"
      ),
  },
  {
    // exams
    path: "/page/course-exams/:id/:courseId",
    name: "QuestionsCourseExams",
    component: () =>
      import(
        /* webpackChunkName:'Questions' */ "../views/Page/CourseExams/components/Questions.vue"
      ),
  },
  // {
  //   // exams
  //   path: '/page/exam/:id',
  //   name: 'Exam',
  //   component: () => import(/* webpackChunkName:'exams' */ '../views/Page/Exams/Exam.vue'),

  // },
  {
    // examsQuestions
    path: "/page/course-exams-questions",
    name: "CourseExamsQuestions",
    component: () =>
      import(
        /* webpackChunkName:'examsQuestions' */ "../views/Page/CourseExamsQuestions/ExamsQuestions.vue"
      ),
  },
  {
    // questions
    path: "/page/course-questions",
    name: "CardCourseQuestions",
    component: () =>
      import(
        /* webpackChunkName:'questions' */ "../views/Page/CourseQuestions/CardQuestions.vue"
      ),
  },
  {
    // questions
    path: "/page/course-questions/:courseId",
    name: "CourseQuestions",
    component: () =>
      import(
        /* webpackChunkName:'CourseQuestions' */ "../views/Page/CourseQuestions/Questions.vue"
      ),
  },
  {
    // program_lists
    path: "/page/course-program-lists",
    name: "CourseProgram_lists",
    component: () =>
      import(
        /* webpackChunkName:'program_lists' */ "../views/Page/CourseProgram_lists/Program_lists.vue"
      ),
  },
  {
    // CourseCertifications
    path: "/page/course-certifications",
    name: "CourseCertifications",
    component: () =>
      import(
        /* webpackChunkName:'CourseCertifications' */ "../views/Page/CourseCertifications/Certifications.vue"
      ),
  },
  {
    // CourseAssignCertificate
    path: "/page/course-assign-certificate",
    name: "CourseAssignCertificate",
    component: () =>
      import(
        /* webpackChunkName:'CourseAssignCertificate' */ "../views/Page/CourseCertifications/AssignCertificate.vue"
      ),
  },

  {
    // QuranPrograms
    path: "/page/alquran-programs/general",
    name: "QuranProgramsGeneral",
    meta: {
      contentClass: "ecommerce-application",
    },
    component: () =>
      import(
        /* webpackChunkName:'QuranPrograms' */ "../views/Page/QuranPrograms/QuranPrograms.vue"
      ),
  },
  {
    // QuranPrograms
    path: "/page/alquran-programs/systemic",
    name: "QuranProgramsSystemic",
    meta: {
      contentClass: "ecommerce-application",
    },
    component: () =>
      import(
        /* webpackChunkName:'QuranPrograms' */ "../views/Page/QuranPrograms/QuranProgramSystemic.vue"
      ),
  },
  {
    // QuranPrograms
    path: "/page/alquran-programs/v2/systemic",
    name: "QuranProgramsSystemicv2",
    meta: {
      contentClass: "ecommerce-application",
    },
    component: () =>
      import(
        /* webpackChunkName:'QuranPrograms' */ "../views/Page/QuranPrograms/QuranProgramSystemic-v2.vue"
      ),
  },
  {
    // QuranProgramStudent
    path: "/page/quran-programs-student",
    name: "QuranProgramStudent",
    component: () =>
      import(
        /* webpackChunkName:'QuranProgramStudent' */ "../views/Page/QuranPrograms/QuranProgramStudent.vue"
      ),
  },
  {
    // QuranProgramStudent
    path: "/page/quran-programs-student-systemic",
    name: "QuranProgramStudentSystemic",
    component: () =>
      import(
        /* webpackChunkName:'QuranProgramStudentSystemic' */ "../views/Page/QuranPrograms/QuranProgramStudentSystemic.vue"
      ),
  },
  {
    // QuranProgramStudent
    path: "/page/student-certifictae",
    name: "StudentCertifictae",
    component: () =>
      import(
        /* webpackChunkName:'StudentCertifictae' */ "../views/Page/QuranPrograms/Certifications.vue"
      ),
  },
  {
    // QuranProgramStudent
    path: "/page/student-certifictae-st",
    name: "StudentCertificationsST",
    component: () =>
      import(
        /* webpackChunkName:'StudentCertificationsST' */ "../views/Page/QuranPrograms/CertificationsST.vue"
      ),
  },
  {
    // CertificationsPreview
    path: "/page/student-certifictae-preview/:id",
    name: "CertificationsPreview",
    component: () =>
      import(
        /* webpackChunkName:'CertificationsPreview' */ "../views/Page/QuranPrograms/CertificationsPreview.vue"
      ),
  },
  {
    // QuranProgramSchedules
    path: "/page/quran-programs-schedules/:id",
    name: "QuranProgramSchedules",
    component: () =>
      import(
        /* webpackChunkName:'QuranProgramSchedules' */ "../views/Page/QuranPrograms/QuranProgramSchedules.vue"
      ),
  },
  {
    // QuranProgramTiming
    path: "/page/quran-programs/:id",
    name: "QuranProgramTiming",
    component: () =>
      import(
        /* webpackChunkName:'QuranScheduleDate' */ "../views/Page/QuranScheduleDate/QuranScheduleDate.vue"
      ),
  },
  {
    // QuranProgramTiming
    path: "/page/quran-programs-now",
    name: "QuranScheduleDateNow",
    component: () =>
      import(
        /* webpackChunkName:'QuranScheduleDateNow' */ "../views/Page/QuranScheduleDate/QuranScheduleDate.vue"
      ),
  },
  {
    path: "/page/quran-programs-date-systemic/:id",
    name: "QuranScheduleDateSystemic",
    component: () =>
      import(
        /* webpackChunkName:'QuranScheduleDateSystemic' */ "../views/Page/QuranScheduleDate/QuranScheduleDateSystemic.vue"
      ),
  },
   {
    path: "/page/quran-programs-date-systemic/v2/:id",
    name: "QuranScheduleDateSystemicv2",
    component: () =>
      import(
        /* webpackChunkName:'QuranScheduleDateSystemic' */ "../views/Page/QuranScheduleDate/QuranScheduleDateSystemicv2.vue"
      ),
  },
  {
    path: "/page/my-quran-program",
    name: "MyQuranProgram",
    component: () =>
      import(
        /* webpackChunkName:'MyQuranProgram' */ "../views/Page/QuranPrograms/MyQuranProgram.vue"
      ),
  },
  {
    // QuranProgramsAssignTeacher
    path: "/page/quran-programs-assign-teacher",
    name: "QuranProgramsAssignTeacher",
    component: () =>
      import(
        /* webpackChunkName:'QuranProgramsAssignTeacher' */ "../views/Page/QuranProgramsAssignTeacher/QuranProgramsAssignTeacher.vue"
      ),
  },
  {
    // MyQuranProgramTeacher
    path: "/page/my-quran-program-teacher",
    name: "MyQuranProgramTeacher",
    component: () =>
      import(
        /* webpackChunkName:'MyQuranProgramTeacher' */ "../views/Page/QuranPrograms/MyQuranProgramTeacher.vue"
      ),
  },
  {
    // QuranProgramReports
    path: "/page/quran-program-reports",
    name: "QuranProgramReports",
    component: () =>
      import(
        /* webpackChunkName:'QuranProgramReports' */ "../views/Page/QuranPrograms/Reports.vue"
      ),
  },
  {
    // Reports
    path: "/page/reports",
    name: "Reports",
    component: () =>
      import(
        /* webpackChunkName:'Reports' */ "../views/Page/Reports/index.vue"
      ),
  },
  {
    // AddWizard
    path: "/page/online-application",
    name: "OnlineApplication",
    component: () =>
      import(
        /* webpackChunkName:'OnlineApplication' */ "../views/Page/OnlineApplication/OnlineApplication.vue"
      ),
  },
  {
    // AddWizard
    path: "/sttings/general",
    name: "SttingsGeneral",
    component: () =>
      import(
        /* webpackChunkName:'SttingsGeneral' */ "../views/Page/Sttings/General.vue"
      ),
  },

  {
    // ApplicationUser
    path: "/page/application-user/:id",
    name: "ApplicationUser",
    component: () =>
      import(
        /* webpackChunkName:'ApplicationUser' */ "../views/Page/Edu_programs/components/profile.vue"
      ),
  },
  {
    // ReadingType
    path: "/page/reading-type",
    name: "ReadingType",
    component: () =>
      import(
        /* webpackChunkName:'ReadingType' */ "../views/Page/ReadingType/ReadingType.vue"
      ),
  },
  //FailedUsersRooms
  {
    // FailedUsersRooms
    path: "/page/failed-users-rooms",
    name: "FailedUsersRooms",
    component: () =>
      import(
        /* webpackChunkName:'FailedUsersRooms' */ "../views/Page/FailedUsersRooms/FailedUsersRooms.vue"
      ),
  },
  //TeacherStudents
  {
    // TeacherStudents
    path: "/page/teacher-student",
    name: "TeacherStudent",
    component: () =>
      import(
        /* webpackChunkName:'QuranPrograms' */ "../views/Page/TeacherStudent/TeacherStudents.vue"
      ),
  },
  {
    // TeacherStudents
    path: "/page/teacher-schedule",
    name: "TeacherSchedule",
    component: () =>
      import(
        /* webpackChunkName:'QuranPrograms' */ "../views/Page/TeacherSchedule/TeacherSchedule.vue"
      ),
  },
  {
    //StudentCourses
    path: "/page/student-courses",
    name: "StudentCourses",
    component: () =>
      import(
        /* webpackChunkName:'StudentCourses' */ "../views/Page/StudentCourses/StudentCourses.vue"
      ),
  },
  {
    path: "/page/statics",
    name: "Statics",
    component: () =>
      import(
        /* webpackChunkName:'Statics' */ "../views/Page/Statics/Statics.vue"
      ),
  },
  {
    path: "/page/students_filter",
    name: "StudentsFilter",
    component: () =>
      import(
        /* webpackChunkName:'Statics' */ "../views/Page/StudentsFilter/StudentsFilter.vue"
      ),
  },
];
export default routes;
